import { getPasswordMessage, MINIMUM_PASSWORD_LENGTH } from "@ac-expo/utils";
import { z } from "zod";

export const updatePasswordSchema = z.object({
  currentPassword: z.string().optional(),
  newPassword: z.string().superRefine((val, ctx) => {
    if (
      val.length < MINIMUM_PASSWORD_LENGTH ||
      !/[a-z]/.test(val) ||
      !/[A-Z]/.test(val) ||
      !/[ !"#$%&'()*+,\-./:;<=>?@[\]^_`{|}~]/.test(val) ||
      !/[0-9]/.test(val)
    ) {
      ctx.addIssue({
        code: z.ZodIssueCode.custom,
        message: getPasswordMessage(val),
      });
    }
  }),
});

export const defaultUpdatePasswordValues = {
  currentPassword: "",
  newPassword: "",
};

export type UpdatePasswordForm = z.infer<typeof updatePasswordSchema>;
